import React from "react";
import AkcioniPlanovi from "../../components/admin/akcioniPlanovi";

function AkcioniPlanoviPage(props) {
  return (
    <div className="admin-page-child-wrapper" style={{ position: "relative" }}>
      <AkcioniPlanovi />
    </div>
  );
}

export default AkcioniPlanoviPage;
